import Image from 'next/image';
import { getImageBasePath } from 'utils/generics';
import * as Styles from './styles';

interface IProps {
    icon: string;
    text: string;
    backgroundColor: string;
    onClick: Function;
    iconBackground: string;
}

function IconTextArrowCard({
    icon,
    text,
    backgroundColor,
    onClick,
    iconBackground,
}: IProps) {
    return (
        <Styles.Wrapper onClick={onClick} backgroundColor={backgroundColor}>
            <Styles.IconFlex>
                <Styles.Icon style={{ backgroundColor: iconBackground }}>
                    <Image
                        width={'40px'}
                        height={'40px'}
                        alt={''}
                        src={getImageBasePath(icon)}
                    />
                </Styles.Icon>
            </Styles.IconFlex>
            <Styles.TextFlex>{text}</Styles.TextFlex>
            <Styles.RightArrowFlex>
                <Image
                    width={'12px'}
                    height={'12px'}
                    alt={''}
                    src={getImageBasePath('/icons/rightArrow.svg')}
                />
            </Styles.RightArrowFlex>
        </Styles.Wrapper>
    );
}

export default IconTextArrowCard;
